import Vue from 'vue'
import Home from './Home.vue'

import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
locale.use(lang)
import { DatePicker, Input, Select, Option, Progress, RadioGroup, Radio } from 'element-ui'
import VueTheMask from 'vue-the-mask'

Vue.use(VueTheMask)

Vue.use(DatePicker)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Progress)
Vue.use(RadioGroup)
Vue.use(Radio)

Vue.filter('formatMoney', (value) => {
  let amount = value
  if (!value) amount = 0
  amount = parseFloat(`${amount}`)
  amount.toFixed(2).replace(/\./g, '.').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return amount
})

Vue.config.productionTip = false

new Vue({
  render: h => h(Home)
}).$mount('#app')
